export type TimeRange = 'all' | 'today' | 'week' | 'month';
export type SortBy = 'latest' | 'hot';

export const timeRanges: { key: TimeRange; label: string }[] = [
  { key: 'all', label: '全部时间' },
  { key: 'today', label: '今天' },
  { key: 'week', label: '7天内' },
  { key: 'month', label: '30天内' },
];

export const sortOptions: { key: SortBy; label: string }[] = [
  { key: 'latest', label: '按发布时间' },
  { key: 'hot', label: '按热度' },
];

interface FilterBarProps {
  timeRange: TimeRange;
  sortBy: SortBy;
  tags: string[];
  activeTag: string;
  onTimeRangeChange: (value: TimeRange) => void;
  onSortChange: (value: SortBy) => void;
  onTagChange: (value: string) => void;
  onReset: () => void;
}

export default function FilterBar({
  timeRange,
  sortBy,
  tags,
  activeTag,
  onTimeRangeChange,
  onSortChange,
  onTagChange,
  onReset,
}: FilterBarProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
        <div className="flex flex-col gap-4 sm:flex-row sm:flex-wrap sm:items-center">
          <div className="flex items-center gap-2">
            <span className="whitespace-nowrap text-sm text-foreground-500">时间范围</span>
            <div className="flex items-center gap-1 rounded-full bg-background-100 p-1">
              {timeRanges.map((item) => (
                <button
                  key={item.key}
                  type="button"
                  onClick={() => onTimeRangeChange(item.key)}
                  className={`whitespace-nowrap rounded-full px-3 py-1 text-xs font-medium transition-colors ${
                    timeRange === item.key
                      ? 'bg-primary-600 text-background-50'
                      : 'text-foreground-600 hover:text-primary-600'
                  }`}
                >
                  {item.label}
                </button>
              ))}
            </div>
          </div>

          <div className="flex items-center gap-2">
            <span className="whitespace-nowrap text-sm text-foreground-500">排序</span>
            <div className="flex items-center gap-1 rounded-full bg-background-100 p-1">
              {sortOptions.map((item) => (
                <button
                  key={item.key}
                  type="button"
                  onClick={() => onSortChange(item.key)}
                  className={`whitespace-nowrap rounded-full px-3 py-1 text-xs font-medium transition-colors ${
                    sortBy === item.key
                      ? 'bg-accent-500 text-primary-950'
                      : 'text-foreground-600 hover:text-accent-700'
                  }`}
                >
                  {item.label}
                </button>
              ))}
            </div>
          </div>
        </div>

        <button
          type="button"
          onClick={onReset}
          className="inline-flex items-center gap-1 self-start whitespace-nowrap text-sm text-foreground-500 transition-colors hover:text-primary-600"
        >
          <i className="ri-refresh-line" />
          重置筛选
        </button>
      </div>

      {tags.length > 0 ? (
        <div className="mt-4 flex flex-wrap items-center gap-2 border-t border-background-200 pt-4">
          <span className="whitespace-nowrap text-sm text-foreground-500">相关标签</span>
          <button
            type="button"
            onClick={() => onTagChange('')}
            className={`rounded-md border px-2.5 py-1 text-xs transition-colors ${
              activeTag === ''
                ? 'border-primary-300 bg-primary-100 text-primary-800'
                : 'border-background-200 bg-background-100 text-foreground-600 hover:border-primary-300'
            }`}
          >
            全部
          </button>
          {tags.map((tag) => (
            <button
              key={tag}
              type="button"
              onClick={() => onTagChange(tag)}
              className={`rounded-md border px-2.5 py-1 text-xs transition-colors ${
                activeTag === tag
                  ? 'border-primary-300 bg-primary-100 text-primary-800'
                  : 'border-background-200 bg-background-100 text-foreground-600 hover:border-primary-300'
              }`}
            >
              #{tag}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}